import styled from "styled-components";
import { color, palette, spacing } from "@conserveit/blocks";

export const Container = styled.button.attrs({ type: "button" })<{
  isSelected: boolean;
}>`
  display: block;
  padding: ${spacing.default};
  width: 100%;
  border: none;
  outline: 0;
  text-align: left;
  border-bottom: 1px solid ${color.theme.divider.solid};
  background: ${(props) =>
    props.isSelected ? palette.neutral2 : color.pureWhite};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${palette.neutral2};
  }
`;

export const ID = styled.h2`
  margin: 0;
  margin-bottom: ${spacing.tight};
  display: inline-block;
  font-size: 12px;
  color: ${palette.neutral7};
`;

export const Summary = styled.h3`
  margin: 0;
  margin-bottom: ${spacing.tight};
  font-size: 14px;
  font-weight: 700;
`;

export const Description = styled.p`
  margin: 0;
  margin-bottom: ${spacing.tight};
  font-size: 12px;
  color: ${palette.neutral6};
`;

export const Opened = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: ${palette.neutral7};
`;
